<template>
    <Dialog v-model="state" :scrollable="false" @close="$emit('close')">
        <div class="confirm-popup" v-loading="loading">
            <div class="confirm-popup__title">
                <p>
                    <span v-html="title"></span>
                    <span class="confirm-popup__count">
                        {{ prettieredQuantity }}
                    </span>
                    <span>
                        {{ countedQuantityText }}.
                    </span>
                </p>
                <p>
                    <span class="confirm-popup__sure">Уверены?</span>
                </p>
            </div>
            <div class="confirm-popup__footer">
                <button
                    class="confirm-popup__footer-button confirm-popup__footer-button--cancel"
                    @click="$emit('close')"
                >
                    Отменить
                </button>
                <button class="confirm-popup__footer-button" @click="$emit('submit')">Отправить рассылку</button>
            </div>
        </div>
    </Dialog>
</template>

<script>
import Dialog from "@/components/UI/Dialog.vue";

export default {
    name: "UserSearchNotificationDialogConfirm",

    components: {Dialog},

    emits: [ "close", "submit" ],

    props: {
        loading: Boolean,
        template: String,
        prettieredQuantity: String,
        countedQuantityText: String,
    },

    data: () => ({
        state: true,
    }),

    beforeMount() {
        this.state = true;
    },

    watch: {
        state(val) {
            if (!val) {
                this.$emit("close");
            }
        },
    },

    computed: {
        title() {
            return this.template === 'push'
                ? 'Вы собираетесь отправить рассылку<br/>Push-уведомлений на'
                : 'Вы собираетесь отправить email-рассылку на'
            ;
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';
@import '~@/styles/variables';

.confirm-popup {
    padding: urem(12);
    @include on-desktop {
        padding: 0;
        width: urem(680);
    }
    &__title {
        text-align: center;
        margin: 0 0 urem(40) 0;
        @include set-font-size(18, 400, 24);

        @include on-desktop {
            @include set-font-size(24, 400, 30);
        }
    }
    &__count {
        font-weight: bold;
        color: $color-main-blue;
    }
    &__sure {
        font-weight: bold;
    }

    &__footer {
        display: flex;
        flex-direction: column-reverse;

        @include on-desktop {
            margin: 0 auto;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }
    }
    &__footer-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: urem(14) urem(32);
        margin-bottom: urem(24);
        background: $color-main-blue;
        border: none;
        border-radius: urem(10);
        text-align: center;
        color: #ffffff;
        @include set-font-size(14, 600, 20);
        @include on-desktop {
            margin-bottom: 0;
            width: auto;
            cursor: pointer;
        }

        &--cancel {
            background: #fff;
            color: $color-main-blue;
            border: 1px solid $color-main-blue;
            @include on-desktop {
                margin: 0 urem(24) 0 0;
            }
        }
    }
}
</style>
